export { resolveImageSrc } from './resolveImageSrc';
